import Request from 'utils/request.js';

const MANAGEMENT_BASE_URL = 'management/products';
const STORE_BASE_URL = 'store/products';

// Store
export const getHighlightedProducts = () => Request.get(`${STORE_BASE_URL}/by-subcategory`);
export const getStoreProducts = (filters) => Request.get(`${STORE_BASE_URL}`, { params: filters });

// Helpers
const toFormData = (data = {}) => {
  const form = new FormData();

  // Campos simples
  if (data.name != null) form.append('name', data.name);
  if (typeof data.price !== 'undefined') form.append('price', String(data.price));
  if (typeof data.promotionalPrice !== 'undefined' && data.promotionalPrice !== null)
    form.append('promotionalPrice', String(data.promotionalPrice));
  if (data.description != null) form.append('description', data.description);
  if (data.technicalSpecifications != null)
    form.append('technicalSpecifications', data.technicalSpecifications);
  if (typeof data.active !== 'undefined') form.append('active', String(Boolean(data.active)));
  if (typeof data.highlighted !== 'undefined')
    form.append('highlighted', String(Boolean(data.highlighted)));
  if (data.categoryId) form.append('categoryId', data.categoryId);
  if (data.subCategoryId) form.append('subCategoryId', data.subCategoryId);

  // Tags (binder ASP.NET: Tags[0].Description, Tags[0].Highlighted, ...)
  if (Array.isArray(data.tags)) {
    data.tags.forEach((t, i) => {
      if (t?.description != null) form.append(`tags[${i}].description`, t.description);
      if (typeof t?.highlighted !== 'undefined')
        form.append(`tags[${i}].highlighted`, String(Boolean(t.highlighted)));
    });
  }

  // Manter imagens atuais (URLs) quando não subir arquivo
  if (Array.isArray(data.images) && data.images.length > 0) {
    data.images.forEach((url) => {
      if (url) form.append('images', url);
    });
  }

  // Novos uploads (substituem o conjunto no backend, conforme implementado)
  const files = Array.from(data.imagesFiles || []);
  files.forEach((file) => form.append('imagesFiles', file));

  return form;
};

// Management (multipart/form-data)
export const getProductById = (id) => Request.get(`${MANAGEMENT_BASE_URL}/${id}`);
export const createProduct = (data) =>
  Request.post(`${MANAGEMENT_BASE_URL}`, toFormData(data), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateProduct = (id, data) =>
  Request.put(`${MANAGEMENT_BASE_URL}/${id}`, toFormData(data), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteProduct = (id) => Request.delete(`${MANAGEMENT_BASE_URL}/${id}`);
export const getProducts = (filters) => Request.get(`${MANAGEMENT_BASE_URL}`, { params: filters });
